<template>
 <div>
  <div class="container" ref="imageDom">

    <div>
      <p>
        1、单务合同和双务合同

        单务合同，是指合同当事人仅有一方承担义务。双务合同，是指合同的双方当事人互负对待给付义务的合同关系。
      </p>

      <p>2、有偿合同和无偿合同

      有偿合同，是指一方通过履行合同规定的义务而给付对方某种利益，对方要得到该利益必须为此支付相应代价的合同。

      无偿合同，是指一方给付某种利益，对方取得该利益时并不支付任何报酬的合同。</p>

      <p>3、有名合同和无名合同

      有名合同，又称典型合同，是指法律上已经确定了一定的名称及规则的合同。

      无名合同，又称非典型合同，是指法律上并未确定一定的名称及规则的合同。</p>

      <p>4、要式合同和不要式合同

      要式合同，是指法律规定或当事人约定必须采取特殊形式订立的合同。

      不要式合同，是指依法无需采取特定形式订立的合同。</p>

      <p>5、主合同和从合同

      主合同，是指不依赖其他合同而能独立存在的合同。

      从合同，是指以其他合同的存在为存在前提的合同，又称为附属合同。</p>

      <p>6、实践合同和诺成合同

      实践合同，是指除当事人双方意思表示一致以外尚须交付标的物才能成立的合同。在这种合同中，除双方当事人的意思表示一致之外，还必须有一方实际交付标的物的行为，才能产生法律效果。实践合同则必须有法律特别规定，比如定金合同，保管合同等。

      诺成合同，是指当事人一方的意思表示一旦经对方同意即能产生法律效果的合同，即“一诺即成”的合同。特点在于当事人双方意思表示一致，合同即告成立。</p>
    </div>

    <div class="esignTest">

          <div style="border: 2px solid #E6E6E6 ;background-color: white">

              <vue-esign ref="esign" :width="1200" :height="300"

                          :isCrop="isCrop"

                          :lineWidth="lineWidth"

                          :lineColor="lineColor"

                          :bgColor.sync="bgColor" />

          </div>

            <button @click="handleReset">重新签名</button>

            <button @click="handleGenerate">确认</button>

    </div>

  </div>
  <div>
    <p>显示图片</p>
    <img v-if="resultImg" :src="resultImg" />
  </div>
 </div>





</template>

<script>
  import html2canvas from "html2canvas"
  export default {
    name:'esignTest',
    data() {
      return {
        lineWidth: 6,
        lineColor: '#000000',
        bgColor: '',
        resultImg: '',
        isCrop: false
      }
    },
    created() {

    },
    methods:{
      handleReset () {
        this.$refs.esign.reset()
        this.resultImg = ''
      },
      handleGenerate () {
        html2canvas(this.$refs.imageDom).then(canvas => {
            this.resultImg = canvas.toDataURL("image/png");
            console.log(this.resultImg)
            // window.open(this.resultImg)
        });
      //   this.$refs.esign.generate().then(res => {
      //       this.resultImg = res

      //       console.log(this.resultImg)
      //    }).catch(err => {
      //       alert(err) // 画布没有签字时会执行这里 'Not Signned'

      //    })
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/qianming.vue